import AssigneePicker from "@/components/PersonPickerDropdown/assigneePicker.component";
import { useUser } from "@/hooks/AppContext/user.hook";
import { AppContext } from "@/services/AppContext/appContext";
import { User } from "lucide-react";
import React, { useContext, useMemo } from "react";

type TimerCellAssigneeProps = {
  className: string;
  editedAssignedTo?: number;
  editing: boolean;
  assignedTo: number | null;
  handleFieldAssignedTo?: (id: number) => void;
  isOpen?: React.MutableRefObject<boolean>;
};

const TimerCellAssignee: React.FC<TimerCellAssigneeProps> = ({
  className,
  editedAssignedTo,
  editing,
  assignedTo,
  handleFieldAssignedTo,
  isOpen,
}) => {
  const { allAppUsers } = useContext(AppContext);
  const { getUserFullNameByID, getUserProfileImageByID } = useUser();

  const assignedImage = useMemo(() => {
    return assignedTo
      ? getUserProfileImageByID(
          editedAssignedTo ? editedAssignedTo : assignedTo
        )
      : null;
  }, [assignedTo, editedAssignedTo, getUserProfileImageByID]);

  return editing && handleFieldAssignedTo && isOpen ? (
    <div className={className}>
      <AssigneePicker
        assignedTo={editedAssignedTo ? editedAssignedTo : null}
        handleFieldAssignedTo={handleFieldAssignedTo}
        isOpen={isOpen}
        modal={false}
      />
    </div>
  ) : (
    <div className={className}>
      {assignedTo ? (
        <div className="flex items-center gap-1">
          {assignedImage ? (
            <img className="size-4 rounded-full shrink-0" src={assignedImage} />
          ) : (
            <User className="size-4 rounded-full bg-primary shrink-0" />
          )}

          {getUserFullNameByID(
            editedAssignedTo ? editedAssignedTo : assignedTo
          )}
        </div>
      ) : (
        <>Not assigned</>
      )}
    </div>
  );
};

export default TimerCellAssignee;
